import React from 'react';
const contents = [{
  emoji: '📘',
  title: '5 Volumes École Primaire',
  desc: 'Programmation annuelle détaillée (CP → CM2) et séances adaptées au développement moteur des Cycles 2 et 3'
}, {
  emoji: '📐',
  title: '4 Volumes Collège',
  desc: "Préparation progressive au Brevet (6ème → 3ème) avec barèmes officiels et gestion de l'hétérogénéité"
}, {
  emoji: '👟',
  title: '3 Volumes Lycée',
  desc: 'Objectif BAC EPS (2nde → Terminale) : organisation des épreuves, dossiers candidats et performance'
}, {
  emoji: '⚽',
  title: '864 Séances Pas à Pas',
  desc: "Avec matériel, schémas, variantes et temps d'exécution chronométrés"
}, {
  emoji: '📊',
  title: "Outils d'Évaluation (LSU & BAC)",
  desc: "Rubriques et grilles d'évaluation prêtes à l'emploi pour chaque niveau scolaire"
}, {
  emoji: '🌱',
  title: 'Contenus Théoriques et Santé',
  desc: "Fiches sur l'hygiène, l'anatomie et les modes de vie sains prêtes à distribuer"
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-4">
            📦 Que contient le Pack EPS PRÊT-À-L'EMPLOI ?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-5">
          {contents.map((item, i) => <div key={i} className="bg-bg-main rounded-3xl p-6 sm:p-8 border border-border-light flex flex-col items-center text-center shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-6">
              <div className="text-4xl sm:text-5xl mb-4" data-id="element-7">{item.emoji}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-text-main mb-2" data-id="element-8">
                {item.title}
              </h3>
              <p className="text-text-sec text-base" data-id="element-9">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}